export default __webpack_public_path__ + "static/media/portada_NickAlbert_ENG.d42877de.jpg";